import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiClusterListState } from './states/cluster-list-state';
import { FiClusterAddState } from './states/cluster-add-state';
import { FiClusterViewState } from './states/cluster-view-state';
import { FiClusterEditState } from './states/cluster-edit-state';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

export const FiClusterRootState: Ng2StateDeclaration = {
    name: FiStateNames.Cluster._name,
    url: '/Cluster',
    abstract: true,
    component: FiAbstractStateComponent,
};

export const FiClusterStates: StatesModule = {
    states: [FiClusterRootState, FiClusterListState, FiClusterAddState, FiClusterViewState, FiClusterEditState],
};
